export const TOGGLE_TOOLTIP = 'TOGGLE_TOOLTIP';

export const toggleTooltip = (name, content = '') => ({
  type: TOGGLE_TOOLTIP,
  data: {
    name,
    content,
  },
});
